import { useState, useEffect } from 'react';
import axios from 'axios';
import { Building2 } from 'lucide-react';
import AgencyLayout from '../layouts/AgencyLayout';
import AgencyHome from '../pages/agency/AgencyHome';
import AgencyProperties from '../pages/agency/AgencyProperties';
import AgencyPropertyDetail from '../pages/agency/AgencyPropertyDetail';
import AgencyAbout from '../pages/agency/AgencyAbout';
import AgencyContact from '../pages/agency/AgencyContact';
import { Routes, Route, Navigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Designated platform domains (add your production domains here)
const PLATFORM_DOMAINS = [
    'localhost',
    '127.0.0.1',
    'estatecloud.in',
    'www.estatecloud.in',
    'estatecloud.com',
    'app.estatecloud.com',
    'estate-cloud.vercel.app'
];

export default function DomainRouter({ children }) {
    const [loading, setLoading] = useState(true);
    const [agency, setAgency] = useState(null);
    const [isCustomDomain, setIsCustomDomain] = useState(false);
    const hostname = window.location.hostname;

    useEffect(() => {
        const checkDomain = async () => {
            // Check if current hostname is a platform domain
            const isPlatform = PLATFORM_DOMAINS.some(domain =>
                hostname === domain || hostname.endsWith('.' + domain)
            );

            if (!isPlatform) {
                try {
                    // If not platform, try to lookup agency by domain
                    const response = await axios.get(`${API_URL}/api/agency/by-domain/${hostname}`);
                    if (response.data) {
                        setAgency(response.data);
                        setIsCustomDomain(true);
                    }
                } catch (error) {
                    console.error('Domain lookup failed:', error);
                    // If domain lookup fails, we still treat it as platform or show 404
                }
            }
            setLoading(false);
        };

        checkDomain();
    }, [hostname]);

    if (loading) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center">
                <div className="text-center">
                    <Building2 className="w-12 h-12 text-sky-500 animate-pulse mx-auto mb-4" />
                    <p className="text-navy-600">Connecting to secure domain...</p>
                </div>
            </div>
        );
    }

    // If we are on a custom domain, we render a specialized set of routes
    // that only include the agency website content
    if (isCustomDomain && agency) {
        return (
            <Routes>
                <Route path="/" element={<AgencyLayout slug={agency.slug} customAgency={agency} />}>
                    <Route index element={<AgencyHome />} />
                    <Route path="properties" element={<AgencyProperties />} />
                    <Route path="property/:propertyId" element={<AgencyPropertyDetail />} />
                    <Route path="about" element={<AgencyAbout />} />
                    <Route path="contact" element={<AgencyContact />} />
                    {/* Redirect any other path to homepage */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        );
    }

    // Otherwise, render the main platform App
    return children;
}
